<template>
  <div>
    <nav class="border-bottom position-relative d-flex justify-content-between">
      <v-tabs show-arrows v-model="activeTab">
        <v-tabs-slider color="teal lighten-3"></v-tabs-slider>
        <v-tab @click="changeTab(0)">
          <span>
            <span v-if="nodeId === 1">{{ this.$t("res_TabsName_Inbox") }}</span>
            <span v-else>{{ this.$t("res_Label_Signed") }}</span>
            <v-badge
              color="#dc3545"
              style="z-index: 90000"
              :content="String(inboxCount || 0)"
              inline
            ></v-badge>
          </span>
        </v-tab>
        <v-tab @click="changeTab(1)">
          <span>
            {{ this.$t("res_TabsName_Sent") }}
            <v-badge
              color="#dc3545"
              style="z-index: 90000"
              :content="String(sentCount || 0)"
              inline
            ></v-badge>
          </span>
        </v-tab>
      </v-tabs>
      <div class="d-flex gap-75 align-items-center grid-list-actions">
        <v-menu
          :left="isLanguageEn"
          :right="!isLanguageEn"
          offset-x
          offset-y
          :close-on-click="true"
          :close-on-content-click="false"
          :value="shown"
          content-class="sm-full-view filter ml-2rem p-0 py-1 px-1"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="btn-sm"
              color="white"
              v-bind="attrs"
              :ripple="false"
              v-on="on"
              @click="shown = true"
            >
              <img src="/assets/images/icons/filter.svg" alt="" />
            </v-btn>
          </template>
          <div class="pt-4" style="min-width: 232px; max-width: 232px">
            <div class="d-flex justify-end">
              <v-btn
                icon
                class="close-btn light-btnd-flex justify-end"
                style="background: none !important; box-shadow: none"
                @click="shown = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
            <div class="flex-1 overflow-auto px-3">
              <h3 class="m-0">{{ $t("res_MenuItems_Filter") }}</h3>
              <div class="pt-5 custom-input">   
                 <div class="mb-4">
                  <v-label>{{ $t("res_Label_Subject") }} </v-label>
                  <v-text-field
                    solo
                    v-model="filter.filterBySubject"
                  ></v-text-field>
                </div>           
                <div class="mb-4">
                  <v-label>{{ $t("res_label_Ref_number") }}</v-label>
                  <v-text-field
                    style="color: black"
                    solo
                    v-model="filter.refNumber"
                  ></v-text-field>
                </div>
                <div class="mb-4">
                  <v-label>{{ $t("res_Label_FromDate") }} </v-label>
                  <v-menu
                    offset-y
                    content-class="p-0"
                    v-model="created_fromdate_datePicker"
                    :close-on-content-click="false"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="utils.dateFormat(filter.FilterByCreatedFromDate)"
                        label=""
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        solo
                        append-icon="mdi-calendar"
                      >
                        <template v-slot:append>
                          <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filter.FilterByCreatedFromDate"
                      :locale="CurrentLangugae"
                      @input="created_fromdate_datePicker = false"
                    ></v-date-picker>
                  </v-menu>
                </div>
                <div class="mb-4">
                  <v-label>{{ $t("res_Label_ToDate") }} </v-label>
                  <v-menu
                    offset-y
                    content-class="p-0"
                    v-model="created_Todate_datePicker"
                    :close-on-content-click="false"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="utils.dateFormat(filter.FilterByCreatedToDate)"
                        label=""
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        solo
                        append-icon="mdi-calendar"
                      >
                        <template v-slot:append>
                          <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filter.FilterByCreatedToDate"
                      :locale="CurrentLangugae"
                      @input="created_Todate_datePicker = false"
                    ></v-date-picker>
                  </v-menu>
                </div>
              
                <div class="mb-4">
                  <v-label>{{ $t("res_Label_DueDate") }} </v-label>
                  <v-menu
                    offset-y
                    content-class="p-0"
                    v-model="due_date_datePicker"
                    :close-on-content-click="false"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="utils.dateFormat(filter.filterByDuedDate)"
                        label=""
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        solo
                        append-icon="mdi-calendar"
                      >
                        <template v-slot:append>
                          <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filter.filterByDuedDate"
                      :locale="CurrentLangugae"
                      @input="due_date_datePicker = false"
                    ></v-date-picker>
                  </v-menu>
                </div>
              </div>
            </div>
            <div class="form-actions m-0 mx-4 py-4">
              <v-btn @click="clearFilters">{{
                $t("res_ButtonText_Clear")
              }}</v-btn>
              <v-btn class="text-primary" @click="applyFilters()">{{
                $t("res_ButtonText_Apply")
              }}</v-btn>
            </div>
          </div>
        </v-menu>
        <v-btn class="btn-sm" color="white" @click="clearFilters()">
          <img src="/assets/images/icons/refresh.svg" alt="" />
        </v-btn>
        <Pagination
          :totalCount="totalRows"
          :pageSize="pagingData.pageSize"
          :pageIndex="pagingData.pageIndex"
          @pageIndexChanged="pageIndexChanged"
          :showPageSize="false"
          style="margin-top: 0px !important"
        />
      </div>
    </nav>
    <div class="tabs-content">
      <v-data-table
        :no-data-text="$t('res_Label_NoData')"
        :headers="grid_headers"
        :items="documentList"
        :items-per-page="pagingData.pageSize"
        :hide-default-footer="true"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        @update:sort-by="updateSortBy"
        @update:sort-desc="updateSortDesc"
        must-sort
        :class="[
          'elevation-1',
          'TasksTable',
          isLanguageEn ? 'align-left' : 'align-right',
        ]"
        item-key="documentId"
      >
        <template v-slot:item="{ item, index }">
          <tr @dblclick="openDocumentDetails(item)">
            <td :class="cellAlignClass" class="serial-cell">
              {{ index + 1 }}
              <span
                v-if="!item.isOpened"
                class="new-indicator"
                :title="$t('res_Label_New')"
              ></span>
            </td>
            <td :class="cellAlignClass">{{ item.subject }}</td>
            <td :class="cellAlignClass">{{ item.referenceNumber }}</td>
            <td :class="cellAlignClass">
              <v-chip v-if="item.priority?.length > 0">
                {{ $t("priority_" + item.priority.toLowerCase()) }}
              </v-chip>
            </td>
            <td :class="cellAlignClass">
              <v-chip
                :style="{
                  backgroundColor: constants.statusesEnum
                    .getById(item.statusId)
                    .data().classColor,
                  color: textColor(
                    constants.statusesEnum.getById(item.statusId).data()
                      .classColor
                  ),
                }"
                v-if="item.status?.length > 0"
              >
                <!-- {{ item.status }} -->
                {{
                  $t(
                    "status_" +
                      constants.statusesEnum.getById(item.statusId).key
                  )
                }}
              </v-chip>
            </td>
            <td :class="cellAlignClass">
              {{ utils.dateFormat(item.createdOn) }}
            </td>
            <td :class="cellAlignClass">
              <span :style="item.balanceDays < 0 ? ' color:red;' : ''">{{
                utils.dateFormat(item.dueDate)
              }}</span>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>
    <v-dialog
      v-model="documentDetailsViewDialog"
      class="full-height-100vh"
      width="100vw"
      height="100vh"
      content-class="overflow-hidden full-height-100vh"
      @keydown.esc="closeDocumentDetailsDialog"
    >
      <DocumentDetailView
        @closeDocumentDetails="closeDocumentDetailsDialog"
        @refreshDocumentList="fetchData"
        :documentId="selectedDocumentId"
        :isSentTab="activeTab === 1"
      />
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import Tabs from "@/components/Tabs.vue";
import * as utils from "@/assets/js/common.js";
import Pagination from "@/components/Pagination.vue";
import constants from "@/assets/js/constants";
import MultiSelect from "vue-multiselect";
import { createVuetify } from "vuetify";
import DocumentDetailView from "@/views/DocumentDetailView.vue";

const defaultFilter = (searchTerm = "") => ({
  refNumber: null,
  filterBySubject: null,
  filterByDuedDate: null,
  FilterByCreatedFromDate: null,
  FilterByCreatedToDate: null,
  FilterByStatusId: null,
  FilterByPriority: null,
  searchTermFilter: searchTerm,
});

export default {
  name: "Tasks",
  components: {
    createVuetify,
    Tabs,
    Pagination,
    utils,
    constants,
    MultiSelect,
    DocumentDetailView,
  },
  props: {
    nodeId: { type: Number },
  },
  data() {
    return {
      documentDetailViewComponentKey: 0,
      selectedDocumentId: 0,
      utils: utils,
      constants: constants,
      CurrentLangugae: "en-us",
      documentList: [],
      selectedDocuments: [],

      searchTermFilter: this.$route?.query?.SearchQuery,
      grid_headers: [],
      loading: true,
      totalRows: 0,
      pagingData: {
        pageSize: 10,
        pageIndex: 0,
        totalCount: 0,
      },
      isAssigned: false,
      activeTab: 0,
      tabs: [{ name: this.$t("res_TabsName_Inbox"), count: 0 }],
      showSearchBoxes: false,
      selectedAttachmentId: 0,
      isLanguageEn: true,
      shown: false,
      filter: defaultFilter(this.$route?.query?.SearchQuery || ""),
      created_fromdate_datePicker: false,
      created_Todate_datePicker: false,
      due_date_datePicker: false,
      loading: false,
      sortBy: "CreatedOn",
      sortDesc: true,
      documentDetailsViewDialog: false,
	  inboxCount: 0,
	  sentCount: 0,
    };
  },
  mounted() {
    this.counts();
    this.CurrentLangugae =
      localStorage.getItem("lang") == "ar" ? "ar-ae" : "en-us";
    this.isLanguageEn = localStorage.getItem("lang") !== "ar";
    this.fetchData();
    setTimeout(function () {
      var headers = document.querySelectorAll(
        ".v-data-table-header th.sortable"
      );
      headers.forEach(function (header) {
        var span = header.querySelector("span");
        var icon = header.querySelector(".v-data-table-header__icon");
        span.append(icon);
      });
    }, 10);
  },
  computed: {
    cellAlignClass() {
      return this.isLanguageEn ? "text-left" : "text-right";
    },
  },
  methods: {
    changeTab(tabIndex) {
      this.filter = defaultFilter(this.$route?.query?.SearchQuery || "");
      this.activeTab = tabIndex;
      this.pagingData.pageIndex = 0;
      this.fetchData();
    },

    updateSortBy(column) {
      if (this.sortBy === column) {
        this.sortDesc = !this.sortDesc;
      } else {
        this.sortBy = column;
        this.sortDesc = column === "CreatedOn" ? true : false;
      }
      this.applyFilters();
    },
    updateSortDesc(desc) {
      this.sortDesc = desc;
      this.applyFilters();
    },

    textColor(color) {
      const hex = color.replace("#", "");
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);
      const luminance = (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
      return luminance > 0.5 ? "#000000" : "#ffffff";
    },

    pageIndexChanged(paging) {
      this.pagingData.pageSize = paging.pageSize;
      this.pagingData.pageIndex = paging.pageIndex;
      this.fetchData();
    },
    counts() {
      axios
        .get(constants.baseApiUrl + 'Document/CorrespondenceCounts')
        .then((res) => {
          if (res == undefined || res.data == null) {
            window.showAlert("res_Msgs_ErrorOccured", "error");
            return false;
          }
          if (!res.data.success) {
            window.showAlert(res.data.message, "error");
            return false;
          }

          this.inboxCount = res.data.data.inboxCount;
          this.sentCount = res.data.data.sentCount;
        })
        .catch((error) => console.log(error))
        .finally(() => window.hideLoading());
    },
    fetchData() {
      window.showLoading();
      this.initPage();
      const formatDateForApi = (value) => {
        if (!value) return null;
        const d = new Date(value);
        return isNaN(d.getTime()) ? null : d.toISOString();
      };

      const formData = {
        Node: this.nodeId,
        FilterByRefNumber: this.filter.refNumber,
        FilterBySubject: this.filter.filterBySubject,
        FilterByDuedDate: formatDateForApi(this.filter.filterByDuedDate),
        FilterByCreatedFromDate: formatDateForApi(
          this.filter.FilterByCreatedFromDate
        ),
        FilterByCreatedToDate: formatDateForApi(
          this.filter.FilterByCreatedToDate
        ),
        PageNumber: this.pagingData.pageIndex,
        PageSize: this.pagingData.pageSize,
        SortBy: (() => {
          const sortFieldMap = {
            referenceNumber: "ReferenceNumber",
            subject: "Subject",
            dueDate: "DueDate",
            CreatedOn: "CreatedOn",
            priority: "Priority",
            status: "Status",
          };
          return sortFieldMap[this.sortBy] || this.sortBy;
        })(),
        SortDir: this.sortDesc ? "DESC" : "ASC",
        SearchTermFilter: this.filter.searchTermFilter,
      };
      const endPointName =
        this.activeTab === 0
          ? "Document/ListDocument"
          : "Document/ListCompletedDocument";
      axios
        .post(constants.baseApiUrl + endPointName, formData)
        .then((res) => {
          debugger;
          if (res == undefined || res.data == null) {
            window.showAlert("res_Msgs_ErrorOccured", "error");
            return false;
          }
          if (!res.data.success) {
            window.showAlert(res.data.message, "error");
            return false;
          }
debugger;
          this.documentList =
            res.data.data.totalCount == 0 ? [] : res.data.data.records;
          this.totalRows = this.pagingData.totalCount =
            res.data.data.totalCount;
        })
        .catch((error) => console.log(error))
        .finally(() => window.hideLoading());
    },
    clearFilters() {
      (this.filter = {
        refNumber: null,
        filterBySubject: null,
        filterByDuedDate: null,
        FilterByCreatedFromDate: null,
        FilterByCreatedToDate: null,
        FilterByStatusId: null,
        FilterByPriority: null,
        searchTermFilter: this.$route?.query?.SearchQuery,
      }),
      this.sortBy = "CreatedOn";
      this.sortDesc = true;
      this.searchTermFilter = "";
      this.applyFilters();
      this.shown = false;
    },
    applyFilters() {
      debugger;
      this.pagingData.pageIndex = 0;
      this.fetchData();
      this.shown = false;
    },
    initPage() {
      const baseHeaders = window.inboxHeaders[this.nodeId]
        .filter((item) => item.show === true)
        .map((g) => {
          g.text = window.translate(g.textKey);
          g.sortable = true;
          g.align = this.isLanguageEn ? "start" : "end";
          return g;
        });

      const headerMap = baseHeaders.reduce((acc, cur) => {
        acc[cur.value] = cur;
        return acc;
      }, {});

      const serialHeader = {
        text: window.translate("res_Label_SerialNumber"),
        value: "serialNumber",
        sortable: false,
        show: true,
        align: "center",
      };

      const createdOnHeader = {
        text: window.translate("res_Label_CreatedOn"),
        value: "CreatedOn",
        sortable: true,
        show: true,
        ordering_disabled: false,
        ordering_text: "res_Label_CreatedOn",
        align: "center",
      };

      this.grid_headers = [
        serialHeader,
        headerMap.subject,
        headerMap.referenceNumber,
        headerMap.priority,
        headerMap.status,
        createdOnHeader,
        headerMap.dueDate,
      ].filter(Boolean);
    },
    openDocumentDetails(item) {
      if (item != null) {
        this.selectedDocumentId = item.documentId;
        this.documentDetailsViewDialog = true;
        this.markDocumentAsOpened(item.documentId);
      }
    },
    markDocumentAsOpened(documentId) {
      axios
        .post(
          constants.baseApiUrl + "Document/MarkAsOpened",
          null,
          { params: { documentId } }
        )
        .catch(() => {});
    },
    closeDocumentDetailsDialog() {
      this.selectedDocumentId = 0;
      this.fetchData();
      this.documentDetailsViewDialog = false;
    },
  },
  watch: {
    $route() {
      this.filter.searchTermFilter = this.$route?.query?.SearchQuery;
    },
    "filter.searchTermFilter": function () {
      this.fetchData();
    },
    nodeId: function () {
      this.fetchData();
    },
  },
};
</script>

<style>
.v-menu__content.theme--light.v-menu__content--fixed.menuable__content__active {
  /* min-width: auto !important; */
}

.TasksTable.align-left thead th span {
  justify-content: flex-start !important;
  text-align: left;
}

.TasksTable.align-right thead th span {
  justify-content: flex-end !important;
  text-align: right;
}

.TasksTable.align-left td {
  text-align: left !important;
}

.TasksTable.align-right td {
  text-align: right !important;
}

.serial-cell {
  display: flex;
  align-items: center;
  gap: 6px;
}

.new-indicator {
  display: inline-block;
  width: 12px;
  height: 12px;
  min-width: 12px;
  border-radius: 50%;
  background-color: var(--primary-button-color, #816238);
  flex-shrink: 0;
}

.small-icon {
  font-size: 4px !important;
  /* Adjust the size as needed */
}

.tooltip-content {
  white-space: nowrap;
  padding: 8px;
  background-color: #7da1c4;
  color: #fff;
  border-radius: 4px;
  font-size: 12px;
  max-width: 200px;
  text-align: center;
}

.theme--light.v-btn.v-btn--has-bg {
  background-color: #fff;
}

.avatar-group {
  margin-right: -8px;
}

.filter-pagination-container {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-right: 20px;
}

.search-btn {
  background-color: #1566b7;
}

.custom-input input {
  color: rgba(0, 0, 0, 0.6) !important;
}

table thead th:first-child span {
  border-radius: 0 !important;
}

table thead th:last-child span {
  border-radius: 0 !important;
}
</style>
